import { ContactNoteStatus } from '../enums/ContactNoteStatus';
import { ContactNote } from '../types/ContactNote';

export function sortNotesByPinned(a: ContactNote, b: ContactNote): number {
    return (
        Number(b.noteStatus === ContactNoteStatus.Pinned) -
        Number(a.noteStatus === ContactNoteStatus.Pinned)
    );
}

export function sortNotesByDate(a: ContactNote, b: ContactNote): number {
    return Number(new Date(b.date)) - Number(new Date(a.date));
}
